import { render, staticRenderFns } from "./ProcessedCorrespondenceLetterList.vue?vue&type=template&id=73267c5d&scoped=true"
import script from "./ProcessedCorrespondenceLetterList.vue?vue&type=script&lang=js"
export * from "./ProcessedCorrespondenceLetterList.vue?vue&type=script&lang=js"
import style0 from "./ProcessedCorrespondenceLetterList.vue?vue&type=style&index=0&id=73267c5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73267c5d",
  null
  
)

export default component.exports